import { render, staticRenderFns } from "./LocationServiceType.vue?vue&type=template&id=e98467ee&"
import script from "./LocationServiceType.vue?vue&type=script&lang=js&"
export * from "./LocationServiceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports